<div
  id="mauticform_wrapper_passo1informacoesiniciais2"
  class="mauticform_wrapper"
>
  <form
    autocomplete="false"
    role="form"
    method="post"
    action="{{ formApiUrl }}?formId=21"
    id="mauticform_passo1informacoesiniciais2"
    data-mautic-form="passo1informacoesiniciais2"
    enctype="multipart/form-data"
    #form
  >
    <div class="mauticform-innerform">
      <div
        class="mauticform-page-wrapper mauticform-page-1"
        data-mautic-form-page="1"
      >
        <div
          id="mauticform_passo1informacoesiniciais2_email"
          data-validate="email"
          data-validation-type="email"
          class="mauticform-row mauticform-email mauticform-field-1 mauticform-required"
        >
          <input
            id="mauticform_input_passo1informacoesiniciais2_email"
            name="mauticform[email]"
            [value]="formData.email"
            class="mauticform-input"
            type="email"
          />
        </div>

        <div
          id="mauticform_passo1informacoesiniciais2_cpf"
          data-validate="cpf"
          data-validation-type="text"
          class="mauticform-row mauticform-text mauticform-field-2 mauticform-required"
        >
          <input
            id="mauticform_input_passo1informacoesiniciais2_cpf"
            name="mauticform[cpf]"
            [value]="formData.cpf"
            class="mauticform-input"
            type="text"
          />
        </div>

        <div
          id="mauticform_passo1informacoesiniciais2_senha"
          data-validate="senha"
          data-validation-type="text"
          class="mauticform-row mauticform-text mauticform-field-3 mauticform-required"
        >
          <input
            id="mauticform_input_passo1informacoesiniciais2_senha"
            name="mauticform[senha]"
            [value]="formData.password"
            class="mauticform-input"
            type="text"
          />
        </div>

        <div
          id="mauticform_passo1informacoesiniciais2_telefone1"
          data-validate="telefone1"
          data-validation-type="text"
          class="mauticform-row mauticform-text mauticform-field-4 mauticform-required"
        >
          <input
            id="mauticform_input_passo1informacoesiniciais2_telefone1"
            name="mauticform[telefone1]"
            [value]="formData.phone"
            class="mauticform-input"
            type="text"
          />
        </div>

        <div
          id="mauticform_passo1informacoesiniciais2_whatsapp"
          data-validate="whatsapp"
          data-validation-type="text"
          class="mauticform-row mauticform-text mauticform-field-8 mauticform-required"
        >
          <input
            id="mauticform_input_passo1informacoesiniciais2_whatsapp"
            name="mauticform[whatsapp]"
            [value]="formData.mobile"
            class="mauticform-input"
            type="text"
          />
        </div>

        <div
          id="mauticform_passo1informacoesiniciais_primeiro_nome"
          data-validate="primeiro_nome"
          data-validation-type="text"
          class="mauticform-row mauticform-text mauticform-field-5 mauticform-required"
        >
          <input
            id="mauticform_input_passo1informacoesiniciais_primeiro_nome"
            name="mauticform[primeiro_nome]"
            [value]="formData.firstname"
            class="mauticform-input"
            type="text"
          />
        </div>

        <div
          id="mauticform_passo1informacoesiniciais_sobrenome"
          data-validate="sobrenome"
          data-validation-type="text"
          class="mauticform-row mauticform-text mauticform-field-6 mauticform-required"
        >
          <input
            id="mauticform_input_passo1informacoesiniciais_sobrenome"
            name="mauticform[sobrenome]"
            [value]="formData.lastname"
            class="mauticform-input"
            type="text"
          />
        </div>

        <div
          id="mauticform_passo1informacoesiniciais_cargo_desejado"
          class="mauticform-row mauticform-text mauticform-field-7"
        >
          <input
            id="mauticform_input_passo1informacoesiniciais_cargo_desejado"
            name="mauticform[cargo_desejado]"
            [value]="formData.desiredJobTitle"
            class="mauticform-input"
            type="text"
          />
        </div>

        <div
          id="mauticform_passo1informacoesiniciais2_sobre_candidato"
          class="mauticform-row mauticform-text mauticform-field-9"
        >
          <input
            id="mauticform_input_passo1informacoesiniciais2_sobre_candidato"
            name="mauticform[sobre_candidato]"
            [value]="formData.aboutme"
            class="mauticform-input"
            type="text"
          />
        </div>
      </div>
    </div>

    <input
      type="hidden"
      name="mauticform[formId]"
      id="mauticform_passo1informacoesiniciais2_id"
      value="21"
    />
    <input
      type="hidden"
      name="mauticform[return]"
      id="mauticform_passo1informacoesiniciais2_return"
      value=""
    />
    <input
      type="hidden"
      name="mauticform[formName]"
      id="mauticform_passo1informacoesiniciais2_name"
      value="passo1informacoesiniciais2"
    />
  </form>
</div>
